import Vue from 'vue'
import Vuex from 'vuex'

import { getField, updateField } from 'vuex-map-fields'

Vue.use(Vuex)

const key = document.getElementById('beambox-embeddable-form').getAttribute("data-key")
const event = document.getElementById('beambox-embeddable-form').getAttribute("data-event")
const provider = document.getElementById('beambox-embeddable-form').getAttribute("data-provider")
const host = window.BASE_URL != undefined ? window.BASE_URL : "https://beambox.com"

const store = new Vuex.Store({
  state: {
    form_fields: [],
    mode: "",
    name: "",
    title_text: "",
    image_url: "",
    show_image: true,
    accent_color: "",
    bg_color: "",
    font: "",
    businessname: "",
    base_url: host,
    country: "+1",
    provider: provider,
  },
  getters: {
    getField,
  },
  mutations: {
    updateField,
    load(state, data) {
      state.form_fields = data.form_fields
      state.mode = data.mode
      state.name = data.name
      state.title_text = data.title_text
      state.image_url = data.image_url
      state.show_image = data.show_image
      state.accent_color = data.accent_color
      state.bg_color = data.bg_color
      state.font = data.font
      state.businessname = data.businessname
      state.country = data.country
    }
  },
  actions: {
    async previewForm({ commit }) {
      fetch(`${host}/api/embeddable_forms/${key}/form?preview=true`, {
        headers: {accept: 'application/json'}
      })
      .then(response => response.json())
      .then(data => commit('load', data))
    },

    async loadForm({ commit }) {

      fetch(`${host}/api/embeddable_forms/${key}/form`, {
        headers: {accept: 'application/json'}
      })
      .then(response => response.json())
      .then(data => commit('load', data) )
    },

    async createGuest({ commit }, formData) {

      fetch(`${host}/api/embeddable_forms/${key}/guest?event_id=${event}`, {
        headers: { accept: 'application/json' },
        method: 'post',
        body: formData,
      })
      .then(response => response.json())
      .then(guest => {
        if (guest.errors) {
          // commit('setErrors', guest.errors)
          console.log(guest.errors)
          document.querySelectorAll(".beambox-error-message").forEach(function(element){
            element.remove()
          })
          if ('email' in guest.errors){
            document.getElementById('email').classList.add("beambox-error")
            document.getElementById('email').insertAdjacentHTML('afterend', `<small class="beambox-error-message">${guest.errors.email.join(' ')}</small>`)
          }
          if ('first_name' in guest.errors){
            document.getElementById('first_name').classList.add("beambox-error")
            document.getElementById('first_name').insertAdjacentHTML('afterend', `<small class="beambox-error-message">${guest.errors.first_name.join(' ')}</small>`)
          }
          if ('country' in guest.errors){
            document.getElementById('country').classList.add("beambox-error")
            document.getElementById('country').insertAdjacentHTML('afterend', `<small class="beambox-error-message">${guest.errors.country.join(' ')}</small>`)
          }
          if ('date_of_birth' in guest.errors){
            document.getElementById('date_of_birth').classList.add("beambox-error")
            document.getElementById('date_of_birth').insertAdjacentHTML('afterend', `<small class="beambox-error-message">${guest.errors.date_of_birth.join(' ')}</small>`)
          }
          if ('gender' in guest.errors){
            document.getElementById('gender').classList.add("beambox-error")
            document.getElementById('gender').insertAdjacentHTML('afterend', `<small class="beambox-error-message">${guest.errors.gender.join(' ')}</small>`)
          }
          if ('full_name' in guest.errors){
            document.getElementById('full_name').classList.add("beambox-error")
            document.getElementById('full_name').insertAdjacentHTML('afterend', `<small class="beambox-error-message">${guest.errors.full_name.join(' ')}</small>`)
          }
          if ('last_name' in guest.errors){
            document.getElementById('last_name').classList.add("beambox-error")
            document.getElementById('last_name').insertAdjacentHTML('afterend', `<small class="beambox-error-message">${guest.errors.last_name.join(' ')}</small>`)
          }
          if ('phone' in guest.errors){
            document.getElementById('phone_number').classList.add("beambox-error")
            document.getElementById('phone_number').insertAdjacentHTML('afterend', `<small class="beambox-error-message">${guest.errors.phone.join(' ')}</small>`)
          }
        } else {
          let height = document.querySelector(`.beambox-main-cont${store.state.mode == 'Popup' ? "" : "-inline"}`).offsetHeight
          document.querySelector(`.beambox-main-cont${store.state.mode == 'Popup' ? "" : "-inline"}`).setAttribute("style", `height: ${height}px;`)
          document.querySelector("#beambox-complete").style.display = "block"
          document.querySelector(".beambox-main-description").remove()
          document.querySelector("#beambox-signup-form").remove()
          if (store.state.mode == "Popup"){
            document.querySelector(".beambox-img-cont").remove()
            setTimeout(function(){
              document.getElementById("beambox-embeddable-form").remove()
            }, 2000)
          }
        }
      })
    }
  }
})

window.store = store
export default store
